import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import TableSort from "../../../../../shared/helpers/table-sort";
import capitalizeFirst from "../../../../../shared/helpers/upper-case";
import TableComponent from "src/core/components/table/table.component";
import { getOTAPublishDeviceById } from "src/store/slices/ota.slice";
import SearchBarComponent from "../../search-bar/search-bar.component";
import { B2Select } from "src/shared/@hdb/biome-2";

function toAcknowledgedFilterValue(value: string): boolean | "" {
  if (value === "true") return true;
  if (value === "false") return false;
  return "";
}

const OTAStatusTableComponent = (props: any) => {
  const [PageNumber, setPageNumber] = useState<number>(1);
  const pageSize = 10;
  const [otaStatusSearchValue, setOtaStatusSearchValue] = useState("");
  const [IsAcknowledged, setIsAcknowledged] = useState<any>("");

  const [SortBy, setSortBy] = useState<any>(capitalizeFirst("publishedOn"));
  const [SortDirection, setSortDirection] = useState<any>("desc");

  const [columns, setColumns] = useState([
    {
      title: "Device ID",
      label: "deviceCode",
      // width: "9rem",
      isSorted: true,
    },
    {
      title: "Published On",
      label: "publishedOn",
      // width: "9rem",
      isSorted: true,
    },
    {
      title: "Acknowledged",
      label: "status",
    },
    {
      title: "Acknowledged On",
      label: "acknowledgedOn",
      // width: "9rem",
      isSorted: true,
    },
  ]);

  const dispatch = useDispatch();

  useEffect(() => {
    if (!props?.data?.id) return;

    dispatch(
      getOTAPublishDeviceById({
        otaId: props?.data?.id,
        PageNumber,
        pageSize,
        SortBy,
        SortDirection,
        SearchText: otaStatusSearchValue || "",
        IsAcknowledged,
      }),
    );
  }, [PageNumber, SortBy, SortDirection, otaStatusSearchValue, IsAcknowledged]);

  const otastatusData = useSelector((state: any) => {
    return state.ota.otaStatusTableData;
  });

  const isLoadingOTA = useSelector((state: any) => {
    return state.ota.isLoadingOTAPublishDeviceById;
  });

  // const onRefetchData = () => {
  //   dispatch(
  //     getOTAPublishDeviceById({
  //       otaId: props?.data?.id,
  //       PageNumber,
  //       pageSize,
  //       SortBy,
  //       SortDirection,
  //       SearchText: otaStatusSearchValue || "",
  //       IsAcknowledged,
  //     })
  //   );
  // };

  const handleChangePage = useCallback((page: number): void => {
    setPageNumber(page);
  }, []);

  const handleChangeSort = useCallback(
    async (sortBy: string, sortDirection: any) => {
      if (!sortBy || !sortDirection) return;
      setSortBy(sortBy);
      setSortDirection(sortDirection);

      const copyColumns: any = await TableSort(columns, sortBy);
      setColumns(copyColumns);
    },
    [],
  );

  const handleSearch = useCallback((searchVal: string): void => {
    setPageNumber(1);
    setOtaStatusSearchValue(searchVal);
  }, []);

  const statusOptions = [
    { label: "Select Status", value: "" },
    { label: "Successful", value: "true" },
    { label: "Failed", value: "false" },
  ];

  return (
    <div>
      <div className="d-flex gap-3 justify-content-end table-generic-action mb-3">
        {/* Use B2Select for status filter */}
        <div className="w-25">
          <B2Select
            name="status"
            optionList={statusOptions}
            onChange={(selectedOption: any) => {
              const value = selectedOption?.value ?? "";
              setPageNumber(1);
              setIsAcknowledged(toAcknowledgedFilterValue(value));
            }}
          />
        </div>

        <SearchBarComponent
          placeholder="Search OTA Device"
          methodToDispatch={getOTAPublishDeviceById}
          getSearch={handleSearch}
        />
      </div>
      <TableComponent
        tableHeaders={columns}
        data={otastatusData?.data}
        totalNumberOfRecords={otastatusData?.numberOfRecords}
        pageSize={pageSize}
        current={PageNumber}
        onChangePage={handleChangePage}
        onChangeSort={handleChangeSort}
        isLoadingData={isLoadingOTA}
      />
    </div>
  );
};

export default OTAStatusTableComponent;
